import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import ProductsEndpoint from '../../persistence/ProductsEndpoint'
const showProduct = { ...defineTypes('SHOW_PRODUCT') }

export const initialState = {
  started: false,
  loading: false,
  loaded: false,
  alwaysOnKegSizes: [],
}

export const actions = {
  showProduct (id) {
    return { type: showProduct.REQUEST, id: id }
  },
}

export const reducer = (state = initialState, action ) => {
  switch (action.type) {
    case showProduct.REQUEST:
      return { ...state, started: true, loading: true }
    case showProduct.FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case showProduct.SUCCESS:
      return { ...state, loading: false, loaded: true, product: action.product }
    case 'REMOVE_KEG_SIZE':
      let product_with_removed_kegs = removeKegSize(state.product, action.keg_size)
      return { ...state, product: product_with_removed_kegs }
    case 'ADD_KEG_SIZE':
      let product_with_added_kegs = addKegSize(state.product, action.keg_size)
      return { ...state, product: product_with_added_kegs }
    default:
      return state
  }
}
const removeKegSize = (product, keg_size) => {
  let current_always_on = alwaysOnInventory(product)
  let index = current_always_on.indexOf(keg_size)
  current_always_on.splice(index, 1)
  let new_array = current_always_on
  let updated_attributes = { ...product && product.attributes, alwaysOnInventory: new_array }
  let updated_product = { ...product, attributes: updated_attributes }
  return updated_product
}

const addKegSize = (product, keg_size) => {
  let current_always_on = alwaysOnInventory(product)
  current_always_on.push(keg_size)
  let new_array = current_always_on
  let updated_attributes = { ...product && product.attributes, alwaysOnInventory: new_array }
  let updated_product = { ...product, attributes: updated_attributes }
  return updated_product
}

const alwaysOnInventory = (product) => {
  return product
    && product['attributes']
    && product['attributes']['alwaysOnInventory']
    && product['attributes']['alwaysOnInventory'].splice(0)
    || []
}

export const selectors = {
  product: (store) => {
    return store.show_product.product
  },
  alwaysOnKegSizes: ({ show_product }) => {
    return show_product.product
      && show_product.product.attributes
      && show_product.product.attributes.alwaysOnInventory || []
  }
}

export function * showProductSaga (action) {
  try {
    const show_product_response = yield call(reduxFetch, ProductsEndpoint.show(action.id))
    if ( show_product_response['data'] ) {
      yield put({ type: showProduct.SUCCESS, product: show_product_response.data })
    } else {
      yield put({ type: showProduct.FAILURE, errors: show_product_response.errors })
    }
  } catch (error) {
    yield put({ type: showProduct.FAILURE, errors: error })
  }
}

export function * rootSaga () {
  yield takeLatest(showProduct.REQUEST, showProductSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/products/show.js